import React, { useEffect } from "react";
import Button from "components/lbc-toolkit/atomics/Button/DefaultButton";
import translations from "translations";
import { Theme, createStyles, makeStyles } from "@material-ui/core";
import { useGetTranscriptOfRecordsLazyQuery } from "graphqlBase/TranscriptOfRecords/__generated__/getTranscriptOfRecords";
import downloadBase64File from "lib/formToolHelpers/downloadBase64File";

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    addButton: {
      fontSize: 14,
      color: theme.colors.tWhite,
      backgroundColor: theme.colors.sunYellow,
      height: 40,
      borderRadius: "unset",
      "&:hover": { color: theme.colors.tWhite, backgroundColor: theme.colors.sunYellow },
    },
  })
);

interface Props {
  id: number;
}

const TranscriptOfRecords: React.FC<Props> = ({ id }) => {
  const classes = useStyles();
  const [query, { data }] = useGetTranscriptOfRecordsLazyQuery({
    fetchPolicy: "network-only",
  });

  const handleClick = () => {
    query({ variables: { studentId: id } });
  };

  useEffect(() => {
    if (!data) {
      return;
    }
    const fileName = data?.transcriptOfRecords?.fileName;
    const base64String = data?.transcriptOfRecords?.fileContentBase64;
    if (!base64String) {
      return;
    }
    downloadBase64File("application/pdf", base64String, `${fileName}`);
  }, [data, id]);

  return (
    <Button
      onClick={handleClick}
      label={`${"Notenübersicht"} ${translations.globals.button.download}`}
      buttonType="primary"
      classes={{ colorPrimary: classes.addButton }}
    />
  );
};

export default TranscriptOfRecords;
